export const SEARCH_FIELD_VALIDATION = {
  required: {
    value: true,
    message: 'Search term is required',
  },
};

export const SEARCH_FIELD_PROPS = {
  name: 'q',
  label: 'Search term',
  placeholder: 'Enter search term...',
  icon: 'search',
};

export const INDEX_FIELD_VALIDATION = {
  required: {
    value: true,
    message: 'Resource is required',
  },
};

export const INDEX_FIELD_PROPS = {
  name: 'index',
  label: 'Resource',
  placeholder: 'Select resource...',
  options: [
    {
      name: 'Company',
      value: 'company',
    },
    {
      name: 'Job',
      value: 'job',
    },
    {
      name: 'Credit',
      value: 'credit',
    },
    // {
    //   name: 'Enterprise',
    //   value: 'enterprise',
    // },
    {
      name: 'All',
      value: 'all',
    },
  ],
};
